import { useQuery } from "@tanstack/react-query";
import { permissionService } from "../api/services/permissions/permissionService";
import { GetPermissionsParams } from "../api/services/permissions/type";

const PERMISSIONS_STALE_TIME =
  Number(process.env.PERMISSIONS_STALE_TIME) || 5 * 60 * 1000; // Default to 5 minutes

export const permissionKeys = {
  all: ["permissions"] as const,
  details: () => [...permissionKeys.all, "detail"] as const,
  detail: (id: string) => [...permissionKeys.details(), id] as const,
};

export const usePermission = (id: string) => {
  return useQuery({
    queryKey: permissionKeys.detail(id),
    queryFn: () => permissionService.getPermission(id),
    enabled: !!id,
    staleTime: PERMISSIONS_STALE_TIME,
  });
};

export const usePermissions = (params: GetPermissionsParams = {}) => {
  return useQuery({
    queryKey: ["permissions", params],
    queryFn: () => permissionService.getPermissions(params),
    staleTime: PERMISSIONS_STALE_TIME,
  });
};

export const useAllPermissions = () => {
  return useQuery({
    queryKey: ["permissions", "all"],
    queryFn: () => permissionService.getAllPermissions(),
    staleTime: PERMISSIONS_STALE_TIME,
  });
};
